
import { v4 as uuidv4 } from 'uuid';

const SDK_Version = "v3.4.26"

export default class StoreManager {
    static userdata = {
        platform: "web",
        os_version: "",
        app_version:SDK_Version,
        device_id: ""
    }
    
    

    static appdata = {
        defaultZoom: 1,
        media: null,
        thisApp: false,
        thisFront: false,
        thisBack: false,
        thisSelfie: false,
        accessToken: "",
        facetecProdKey: "",
        requestId: "",
        isMobile: false,
        rawImage: {
            front: "",
            back: "",
            selfie: ""
        },
        callback: () => { },

        configEkyc: {
            domain: "",
            configEndpoint: {
                front: "",
                back: "",
                selfie: "",
                complete: "",
                nfcqrverify: "",
                nfcrar: "",
                ocr: "",
                nfcbshield: "",
                createrequest: "",
                accesstoken: ""
            },
            clientId: "",
            clientSecret: "",
            configHeader: "",
            stepVerification: ["FRONT", "BACK", "SELFIE", "EDITOCR"],
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
            ocrFieldsConfig: {
                fullName:   { visible: true,  editable: true },
                dateOfBirth:{ visible: true,  editable: true },
                gender:     { visible: true,  editable: true },
                idNumber:   { visible: true,  editable: false },
                givenDate:  { visible: true,  editable: true },
                dueDate:    { visible: true,  editable: true },
                placeOfIssue:{ visible: true, editable: true },
                permanentAddress:{ visible: true, editable: true },
            },
        },
        configFaceEnroll: {
            domain: "",
            enrollEndPoint:"",
            accesstokenEndPoint: "",
            createRequestEndPoint:"",
            configHeader:"",
            clientId: "",
            clientSecret: "",
            personId:"",
            transId:"",
            configHeader: "",
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
         
        },
        configFaceAuthen: {
            domain: "",
            authenEndPoint:"",
            accesstokenEndPoint: "",
            createRequestEndPoint:"",
            configHeader:"",
            clientId: "",
            clientSecret: "",
             personId:"",
            transId:"",
            configHeader: "",
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
         
        },
        editOCR: {
            fullName: '',
            dateOfBirth: '',
            gender: '',
            idNumber: '',
            givenDate: '',
            placeOfIssue: '',
            permanentAddress: ''
        },
        sdkHistories:[]
    }
    static stopStream = () => {
        return new Promise((resolve) => {
            this.appdata.media?.getTracks().forEach(function (track) {
                track.stop();
            });
            // console.log("stopStream")

            // Sau khi tất cả track đã dừng, đặt media về null và resolve promise
            this.appdata.media = null;
            resolve();
        });
    }
    
    static getOSInfo = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        let osName = 'Unknown OS';
        let osVersion = 'Unknown Version';
    
        if (/Mac/i.test(platform)) {
          osName = 'MacOS';
          const macVersion = userAgent.match(/Mac OS X (10[\.\_\d]+)/);
          if (macVersion) {
            osVersion = macVersion[1].replace(/_/g, '.');
          }
        } else if (/Win/i.test(platform)) {
          osName = 'Windows';
          const winVersion = userAgent.match(/Windows NT (\d+\.\d+)/);
          if (winVersion) {
            osVersion = winVersion[1];
            switch (osVersion) {
              case '10.0':
                osVersion = '10';
                break;
              case '6.3':
                osVersion = '8.1';
                break;
              case '6.2':
                osVersion = '8';
                break;
              case '6.1':
                osVersion = '7';
                break;
              default:
                osVersion = 'Unknown Version';
            }
          }
        } else if (/Android/i.test(userAgent)) {
          osName = 'Android';
          const androidVersion = userAgent.match(/Android (\d+(\.\d+)?)/);
          if (androidVersion) {
            osVersion = androidVersion[1];
          }
        } else if (/iOS/i.test(userAgent)) {
          osName = 'iOS';
          const iosVersion = userAgent.match(/OS (\d+)_\d+/);
          if (iosVersion) {
            osVersion = iosVersion[1];
          }
        } else if (/Linux/i.test(platform)) {
          osName = 'Linux';
        }
        return ` ${osName} _ ${osVersion}`
      };
    

static loadMediaStream = () => {
    if (this.appdata.media != null) {
        console.log("♻️ Reuse existing stream");
        return Promise.resolve(this.appdata.media);
    }

    return new Promise((resolve, reject) => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !navigator.mediaDevices.enumerateDevices) {
            reject("Media devices not supported");
            return;
        }

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        this.appdata.isMobile = isMobile;

        console.log("isMobile", isMobile, "| isIOS", isIOS, "| isSafari", isSafari);

        if (isMobile) {
            navigator.mediaDevices.enumerateDevices()
                .then(devices => {
                    const videoDevices = devices.filter(d => d.kind === "videoinput");
                    console.log("🎥 videoDevices:", videoDevices.map(d => d.label));

                    const backCameras = videoDevices.filter(d => /back/i.test(d.label));
                    console.log("📸 backCameras:", backCameras.map(d => d.label));

                    let backCamera = null;

                    if (isIOS) {
                        // ✅ Ép chọn “Back Wide” hoặc “Back Camera”
                        backCamera =
                            backCameras.find(d => /wide/i.test(d.label)) ||
                            backCameras.find(d => /back camera/i.test(d.label)) ||
                            backCameras.find(d => /back/i.test(d.label)) ||
                            videoDevices[0];

                        console.log("🍏 iOS selected:", backCamera?.label);
                    } else {
                        // ✅ Android giữ nguyên
                        backCamera =
                            backCameras.length > 0
                                ? backCameras[backCameras.length - 1]
                                : videoDevices[0];

                        console.log("🤖 Android selected:", backCamera?.label);
                    }

                    if (!backCamera) throw new Error("No back camera found");

                    const constraints = {
                        video: {
                            ...(backCamera.deviceId ? { deviceId: { exact: backCamera.deviceId } } : {}),
                            facingMode: "environment",
                            width: { ideal: 600 },
                            height: { ideal: 800 },
                            frameRate: { ideal: 30 }
                        }
                    };

                    // Safari fix: tránh crash khi có deviceId nhưng camera group logic
                    if (isSafari) {
                        delete constraints.video.deviceId;
                    }

                    console.log("🎛 constraints", constraints);
                    return navigator.mediaDevices.getUserMedia(constraints);
                })
                .then(stream => {
                    this.appdata.media = stream;

                    const track = stream.getVideoTracks()[0];
                    const settings = track.getSettings();
                    console.log("🎞️ Active Camera:", settings.label, settings.width, settings.height, settings.frameRate);

                    // ✅ Reset zoom về 1.0 nếu có hỗ trợ
                    const caps = track.getCapabilities();
                    if (caps.zoom && track.applyConstraints) {
                        track.applyConstraints({ advanced: [{ zoom: 1.0 }] })
                            .then(() => console.log("🔧 Zoom reset to 1.0"))
                            .catch(e => console.warn("Zoom reset failed:", e));
                    }

                    resolve(stream);
                })
                .catch(error => {
                    console.error("❌ Error accessing the camera:", error);
                    reject(error);
                });
        } else {
            // ✅ Desktop giữ nguyên
            const constraints = {
                video: {
                    facingMode: "environment",
                    width: { ideal: 800 },
                    height: { ideal: 600 },
                    frameRate: { ideal: 30 }
                }
            };
            navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    this.appdata.media = stream;
                    console.log("💻 Desktop camera opened");
                    resolve(stream);
                })
                .catch(error => reject(error));
        }
    });
};


    static loadSelfieMediaStream = () => {
        return new Promise((resolve, reject) => {
            // Kiểm tra hỗ trợ MediaDevices và các phương thức cần thiết
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !navigator.mediaDevices.enumerateDevices) {
                console.error("Media devices or getUserMedia is not supported by this browser.");
                reject("Media devices or getUserMedia not supported.");
                return;
            }
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            this.appdata.isMobile = isMobile
            // Dừng stream hiện có (nếu có) để giải phóng camera
            if (this.appdata && this.appdata.media) {
                this.appdata.media.getTracks().forEach(track => track.stop());
                this.appdata.media = null;
            }
    
            // Kiểm tra các constraints được hỗ trợ
            const supports = navigator.mediaDevices.getSupportedConstraints();
            console.log("Supported constraints:", supports);
    
            // Thiết lập cấu hình video với facingMode "user"
            const videoObj = {
                width: { ideal: 1280 },
                height: { ideal: 720 },
                advanced: [{ facingMode: "user" }]
            };
            const constraints = { video: videoObj };
    
            // Gọi getUserMedia để truy cập camera
            navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {

                    this.appdata.media = stream;

                    resolve(stream);
                })
                .catch(error => {
                    // Xử lý lỗi chi tiết để xác định nguyên nhân
                    if (error.name === "NotReadableError") {
                        console.error("Camera is in use by another application or failed to start:", error);
                    } else if (error.name === "OverconstrainedError") {
                        console.error("Camera constraints are not supported by this device:", error);
                    } else if (error.name === "NotAllowedError") {
                        console.error("Camera access was denied:", error);
                    } else {
                        console.error("An unexpected error occurred while accessing the camera:", error);
                    }
                    reject(error);
                });
        });
    };

    
    // static loadSelfieMediaStream = () => {
    //     // console.log("loadSelfieMediaStream")
    //     return new Promise((resolve, reject) => {
    //         if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia && navigator.mediaDevices.enumerateDevices) {
    //             const supports = navigator.mediaDevices.getSupportedConstraints();
    //             // console.log("supports", supports)
    //             var videoObj = {
    //                 width: { ideal: 800 },
    //                 height: { ideal: 600 },
    //                 facingMode: "user"
    //             };
    //             const constraints = { video: videoObj };

    //             navigator.mediaDevices.getUserMedia(constraints)
    //                 .then(stream => {
    //                     this.appdata.media = stream;
    //                     // console.log("resolve(stream);")
    //                     resolve(stream);
    //                 })
    //                 .catch(error => {
    //                     console.error("Error accessing the camera: ", error);
    //                     reject(error);
    //                 });
    //         } else {
    //             console.log("Media devices not supported")
    //             reject("Media devices not supported");
    //         }
    //     });
    // };
    static rootState = {
    }
    static async loadDataFromLocal() {
        var data = localStorage.getItem(`ekycuserdata_${SDK_Version}`)
        if (data) {
            this.userdata = JSON.parse(data)
            this.userdata.app_version = SDK_Version
        }else {
            let os = StoreManager.getOSInfo()
            this.userdata = {
                platform: "web",
                os_version: os,
                app_version: SDK_Version,
                device_id : uuidv4()
            } 
            this.updateDataToLocal()
        }
    }
    static updateDataToLocal() {
        localStorage.setItem(`ekycuserdata_${SDK_Version}`, JSON.stringify(this.userdata))
    }
    static resetState = () => {
        this.rootState = {
        }
        this.appdata =  {
        defaultZoom: 1,
        media: null,
        thisApp: false,
        thisFront: false,
        thisBack: false,
        thisSelfie: false,
        accessToken: "",
        facetecProdKey: "",
        requestId: "",
        isMobile: false,
        rawImage: {
            front: "",
            back: "",
            selfie: ""
        },
        callback: () => { },

        configEkyc: {
            domain: "",
            configEndpoint: {
                front: "",
                back: "",
                selfie: "",
                complete: "",
                nfcqrverify: "",
                nfcrar: "",
                ocr: "",
                nfcbshield: "",
                createrequest: "",
                accesstoken: ""
            },
            clientId: "",
            clientSecret: "",
            configHeader: "",
            stepVerification: ["FRONT", "BACK", "SELFIE", "EDITOCR"],
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
            ocrFieldsConfig: {
                fullName:   { visible: true,  editable: true },
                dateOfBirth:{ visible: true,  editable: true },
                gender:     { visible: true,  editable: true },
                idNumber:   { visible: true,  editable: false },
                givenDate:  { visible: true,  editable: true },
                dueDate:    { visible: true,  editable: true },
                placeOfIssue:{ visible: true, editable: true },
                permanentAddress:{ visible: true, editable: true },
            },
        },
        configFaceEnroll: {
            domain: "",
            enrollEndPoint:"",
            accesstokenEndPoint: "",
            createRequestEndPoint:"",
            configHeader:"",
            clientId: "",
            clientSecret: "",
            personId:"",
            transId:"",
            configHeader: "",
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
         
        },
        configFaceAuthen: {
            domain: "",
            authenEndPoint:"",
            accesstokenEndPoint: "",
            createRequestEndPoint:"",
            configHeader:"",
            clientId: "",
            clientSecret: "",
             personId:"",
            transId:"",
            configHeader: "",
            titleColor: "#091E42CC", // 80%
            subTitleColor: "#091E4299", // 60%
            closeColor: "#091E42CC", // 80%
            buttonCaptureColor: "#1182E7",
            titleButtonCaptureColor: "#ffffff",
            ovalColor: "#006cab", // 80%
            stepBarColor: "#006cab",
            stepBarBackgroundColor: "#D3D9E0",
            backgroundColor: "#ffffff",
            requestId: '',
            accessToken: '',
            maxRetry: 3,
            sdkKey:'',
            libFacePath:["/trueidsdk/wasm/blaze_face_short_range.tflite","/trueidsdk/wasm/blaze_face_short_range.tflite"],
         
        },
        editOCR: {
            fullName: '',
            dateOfBirth: '',
            gender: '',
            idNumber: '',
            givenDate: '',
            placeOfIssue: '',
            permanentAddress: ''
        },
        sdkHistories:[]
    }

    }
    
}
